import React from "react";
import { Button } from "@/components/Global/Button/Button";

interface ExternButtonProps {
  label: string;
  onClick: (clickEvent: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ExternButton = ({ label, onClick }: ExternButtonProps) => {
  return (
    <Button
      href=""
      target="_blank"
      type="primary"
      onClick={onClick}
      className="ghost mx-auto mt-4"
      // className={`button-reset btn ${styles["extern-button"]} ${buttonStyles.btn} ${buttonStyles["is-primary"]}`}
      icon={"logoGoogleSVG"}
    >
      {label}
    </Button>
  );
};
